<template>
  <div class="system-wrapper-left">
    <div class="system-wrapper-left-top">
      <div class="system-wrapper-left-top-div">
        <p>新闻中心</p>
        <p>News centres</p>
      </div>
    </div>
    <div class="news-list-left-sub-nav-list"><!--newsCenter-->
      <p class="news-list-left-sub-nav active" v-for="item in newsCenter" :key="item.id" @click="newsCenterClick(item.id)">{{item.name}}</p>
    </div>
    <div class="system-wrapper-left-top">
      <div class="system-wrapper-left-top-div">
        <p>阅读推荐</p>
        <p>Recommendation</p>
      </div>
    </div>
    <div class="news-list-left-sub-nav-list">
      <a class="news-list-left-a active" v-for="item in recList" :key="item.id" @click="recListClick(item.id)">{{item.title}}</a>
    </div>
    <div class="system-wrapper-left-top">
      <div class="system-wrapper-left-top-div">
        <p>查看销量排行</p>
        <p>Sales ranking</p>
      </div>
    </div>
    <div class="system-wrapper-left-list">
      <div class="system-wrapper-left-list-item" v-for="item in imgList" :key="item.id" @click="imgListClick(item.id)">
        <img :src="item.img" alt="">
      </div>
    </div>
  </div>
</template>

<script>
    import tool from '@/assets/js/tool.js'
    export default {
        name: "new-list-left",
        data() {
            return {
                newsCenter:[],
                recList:[],
                imgList:[],
            }
        },
        mounted() {
            this.getData();
        },
        methods: {
            getData(){
                let data={
                    information_category_id:'',
                    page:1,
                    page_size:22,
                };
                tool.postData('get_info_list',data,(res) => {
                    this.recList=res.data.data.rec_list||[];
                    this.newsCenter = res.data.data.category_two||[];
                });
                let data2={
                    page:1,
                    page_size:3,
                };
                tool.postData('get_goods_list',data2,(res) => {
                    this.imgList=res.data.data.goods_list.data||[];
                });
            },
            newsCenterClick(id){
                this.$emit ('navClick', id);
                this.$router.push("/newsList/?id="+id);
                window.scrollTo(0,0);
            },
            recListClick(id){
                this.$emit ('leftClick', id);
                this.$router.push('/newsListDetail?Nid='+id);
                window.scrollTo(0,0);
            },
            imgListClick(id){
                //this.$emit ('leftClick', id);
                this.$router.push('/chSystemDetail/?id='+id);
                window.scrollTo(0,0);
            }
        }
    }

</script>

<style scoped lang="scss">
  @import "../../assets/style/common";
  .system-wrapper-left{
    width: 289px;
    background-color: #fff;
    .system-wrapper-left-top{
      width: 100%;
      height: 90px;
      background-color: #3b6bda;
      display: flex;
      align-items: center;
      padding-left: 20px;
      box-sizing: border-box;
      .system-wrapper-left-top-div{
        border-left: 2px solid #fff;
        p{
          @include font(24px,#fff);
          margin-left: 10px;
        }
      }
    }
    .system-wrapper-left-list{
      padding: 19px;
      box-sizing: border-box;
      .system-wrapper-left-list-item{
        width: 100%;
        height: 159px;
        border-radius: 7px;
        margin-bottom: 20px;
        //padding: 37px 10px 20px;
        box-sizing: border-box;
        background: #999;
        img{
          width: 100%;
          height: 100%;
          &:hover{
            cursor: pointer;
          }
        }
        /*.icon{
          display: flex;
          align-items: center;
          span{
            @include font(18px,#fff);
            margin-left: 10px;
          }
        }
        .txt{
          @include font(16px,#fff);
          text-align: center;
          line-height: 25px;
          margin-top: 20px;
        }
        &:nth-child(1){
          background: #3169e3 url("../../../static/img/ts-img/edu-bg-wen.png") repeat;
        }
        &:nth-child(2){
          background: #ee3244 url("../../../static/img/ts-img/edu-bg-wen.png") repeat;
        }
        &:nth-child(3){
          background: #f16d1a url("../../../static/img/ts-img/edu-bg-wen.png") repeat;
        }*/
      }

    }
    .news-list-left-sub-nav-list{
      background-color: #fff;
      padding: 10px 0;
      .news-list-left-sub-nav{
        line-height: 74px;
        text-align: center;
        @include font(24px,#666);
        border-bottom: 1px solid #c4d2f4;
        &:last-child{
          border-bottom: none;
        }
        /*&.active{
          color: #3b6bda;
        }*/
        &:hover{cursor: pointer;color: #3b6bda}
      }
      .news-list-left-a{
        display: block;
        width: 100%;
        line-height: 74px;
        @include font(16px,#666);
        border-bottom: 1px solid #c4d2f4;
        white-space: nowrap;
        overflow: hidden;
        text-overflow: ellipsis;
        padding: 0 20px;
        box-sizing: border-box;
        cursor: pointer;
        &:last-child{
          border-bottom: none;
        }
        &:hover{
          color: #3b6bda;
        }
      }
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/news-list-left/new-list-left.vue